import React, { CSSProperties } from 'react';
import ReactMarkdown from 'react-markdown';
import { CopilotMessage } from '@fluentui-copilot/react-copilot';
import { IStyledComponent } from 'common/Common.types';
import { Text } from 'common/components/Text';
import { useLocalizedStrings } from 'i18n';
import { isApiCallComplete, isApiCallFailed } from 'store/apiCallResultStatus';

import { IChatHistoryItem } from './Chat.types';

interface IChatHistoryItemResponseProps extends IStyledComponent {
  item: IChatHistoryItem;
  showDebugInfo?: boolean;
}

// i18next-extract-mark-ns-start copilot
export const ChatHistoryItemResponse = (props: IChatHistoryItemResponseProps) => {
  const { className, item, styles, showDebugInfo = false } = props;
  const { apiStatus, response, metadata } = item;
  const responseLoading = !isApiCallComplete(apiStatus);
  const hasError = isApiCallFailed(apiStatus);

  const { t } = useLocalizedStrings('copilot');

  return (
    <CopilotMessage isLoading={responseLoading} className={className} style={styles?.root as CSSProperties}>
      {!responseLoading && hasError && <Text>{t('ChatControl.Response.Error')}</Text>}
      {!responseLoading && response && (
        <>
          <ReactMarkdown className={className}>{response}</ReactMarkdown>
          {showDebugInfo && (
            <div>
              <div style={{ fontSize: '0.9rem' }}>{metadata?.duration && `${metadata?.duration}`}</div>
              <div style={{ fontSize: '0.9rem' }}>
                {metadata?.chatTokenUsage &&
                  `PromptTokens: ${metadata?.chatTokenUsage.promptTokens},
                CompletionTokens: ${metadata?.chatTokenUsage.completionTokens}`}
              </div>
            </div>
          )}
        </>
      )}
    </CopilotMessage>
  );
};
// i18next-extract-mark-ns-stop copilot
